import(/* webpackMode: "eager" */ './pt-state.scss')
